import React from "react";
import "./App.css";
// react-router-dom
import { BrowserRouter, Route, Switch } from "react-router-dom";
// react-redux
import { Provider } from "react-redux";
import store from "./store/index";
// @material-ui
import { makeStyles } from "@material-ui/core/styles";
import MainView from "./view/MainView/MainView";
import AboutView from "./view/AboutView/AboutView";
import Footer from "./components/Footer/Footer";
import styles from "./AppStyle";
const useStyles = makeStyles(styles);

function App() {
  const classes = useStyles();
  return (
    <Provider store={store}>
      <div className={classes.App}>
        <BrowserRouter>
          <Switch>
            <Route exact path="/" component={MainView} />
            <Route exact path="/about" component={AboutView} />
            <Route
              exact
              path="/:year/:month/:day/:slug/"
              component={MainView}
            />
            <Route
              exact
              path="/:category/:category/:categoryId"
              component={MainView}
            />
            <Route exact path="/:category/:categoryId" component={MainView} />
            <Route component={MainView} />
          </Switch>
        </BrowserRouter>
        <Footer />
      </div>
    </Provider>
  );
}

export default App;
